import {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import { useMetaTags } from '../../services/useMetaTags';
import {NavLink} from 'react-router-dom';
import '../../assets/styles/promoCodes/promoCodes.scss';

export default function PromoCodesListPage() {
    const {t} = useTranslation();
    const [promoActions, setPromoActions] = useState([]);

    useMetaTags({
        title: t('menu.promocodes'),
        description: t('app.description'),
        metas: [{name: 'keywords', content: t('app.keywords')}],
    });

    useEffect(() => {
        fetch('/api/v1/promoCodes', {credentials: 'same-origin'})
            .then((response) => response.json())
            .then((payload) => {
                setPromoActions(Array.isArray(payload?.promoActions) ? payload.promoActions : []);
            });
    }, []);

    const items = useMemo(() => promoActions, [promoActions]);

    return (
        <section className="promo-codes-page">
            <div className="container">
                <nav className="navigation-promo">
                    <NavLink exact to="/promoCodes" activeClassName="active" title={t('promoCodes.tabs.added')}>{t('promoCodes.tabs.added')}</NavLink>
                    <NavLink exact to="/activatePromoCode" activeClassName="active" title={t('promoCodes.tabs.activate')}>{t('promoCodes.tabs.activate')}</NavLink>
                </nav>
                {!items.length && (
                    <div className="form-wrap">
                        <h1>{t('promoCodes.empty')}</h1>
                    </div>
                )}
                <div className="promo-codes-grid">
                    {items.map((item, index) => (
                        <div
                            key={`${item.code}-${item.url}-${index}`}
                            className="promo-code-item"
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                window.location.href = item.url;
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    window.location.href = item.url;
                                }
                            }}
                        >
                            <div className="img-wrap">
                                <img src={item.image} alt="" className="img-fill"/>
                            </div>
                            <div className="info-block">
                                <h6>{t('promoCodes.promoCaption')} {item.code}</h6>
                                <p className="term-date">
                                    {t('promoCodes.expiresAt')}
                                    <span>{item.dateTerm || t('promoCodes.unlimited')}</span>
                                </p>
                            </div>
                            {!!item.sponsors?.length && (
                                <div className="sponsors-block">
                                    <div className="wrapper">
                                        {item.sponsors.map((sponsor, sponsorIndex) => (
                                            <div key={`${item.code}-sponsor-${sponsorIndex}`}>
                                                {sponsor.url ? (
                                                    <a
                                                        href={sponsor.url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        onClick={(event) => event.stopPropagation()}
                                                    >
                                                        <img alt="" src={sponsor.image}/>
                                                    </a>
                                                ) : (
                                                    <img alt="" src={sponsor.image}/>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
